import React, {memo, useEffect} from 'react';
import cn from 'classnames';
import {useScriptInjector} from '@/common/services/headTagger';
import styles from './MarketGidAdBanner.css';

interface MarketGidAdBannerProps {
	className?: string;
	blockId: string;
	scriptSrc: string;
	placeholder?: boolean;
}

export const MarketGidAdBanner = memo<MarketGidAdBannerProps>(props => {
	const {className, blockId, scriptSrc, placeholder} = props;

	const removeScript = useScriptInjector({
		src: scriptSrc,
		async: true,
	});

	useEffect(() => {
		return () => {
			removeScript();
		};
	}, []);

	return (
		<div
			className={cn(styles.root, placeholder && styles.withPlaceholder, className)}
			id={blockId}
			suppressHydrationWarning
		/>
	);
});

MarketGidAdBanner.displayName = 'MarketGidAdBanner';
